module.exports = __webpack_public_path__ + "static/media/send.bac88b20.svg";